export default "__VITE_ASSET__5h7gfxi4__"